import React, { useState, useEffect } from 'react';
import { 
  DeleteForever 
} from '@mui/icons-material';

import FabButton from "@components/input/buttons/FabButton";
import { Button } from '@mui/material';
import ModalOrDrawer from '@components/display/ModalOrDrawer';
import FlexBox from '@components/layout/FlexBox';
import DandDButtonBox from '@dndComponents/DandDButtonBoxSimple';
// import MyMuiButton from './MyMuiButton';

interface Props {
  disabled?: boolean;
  label?: string;
  no_fab?: boolean;
  confirm_message?: string;
  no_confirm?: boolean;
  onClick: () => void;
}

export default function DeleteButton({ 
  disabled = false,
  label = "",
  no_fab = false,
  confirm_message: param_confirm_message,
  no_confirm = false,
  onClick 
}: Props) {
  const [is_disabled, setDisabled] = useState(disabled);
  const [confirm_open, setConfirmOpen] = useState(false);

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const className =`${is_disabled ? " disabled" : ""}`;

  const renderExtras = () => {
    const confirm_message = param_confirm_message ? param_confirm_message : `Are you sure you want to delete ${ label === "" ? "this" : label}? This cannot be undone.`;
    return (
      <>
        <ModalOrDrawer open={confirm_open} onClose={() => setConfirmOpen(false) }>
          <FlexBox direction="column">
            <FlexBox>{confirm_message}</FlexBox>
            <FlexBox>
              <div style={{ float: "right", width: "200px" }}>
                <FlexBox direction="row">
                  <FlexBox>
                    <DandDButtonBox name="Delete" color="red" onClick={ async () => {
                      onClick();
                    }}/>
                  </FlexBox>
                  <FlexBox>
                    <DandDButtonBox name="Cancel" onClick={() => {
                      setConfirmOpen(false);
                    }}/>
                  </FlexBox>
                </FlexBox>
              </div>
            </FlexBox>
          </FlexBox>
        </ModalOrDrawer>
      </>
    )
  }

  const handleClick = () => {
    if (no_confirm) {
      onClick();
    } else {
      setConfirmOpen(true);
    }
  }

  if (label === "") {
    const fab = !no_fab;
    if (fab) {
      return (
        <FabButton
          disabled={disabled} 
          onClick={handleClick}>
          <DeleteForever/>
          { renderExtras() }
        </FabButton>
      );
    } else {
      return (
        <>
          <DeleteForever className="clickable"
            onClick={handleClick}
          />
          { renderExtras() }
        </>
      );
    }
  } else {
    return (
      <>
        <Button 
          className={className}
          disabled={disabled} 
          onClick={handleClick}
          variant="contained" color="primary">
          <DeleteForever/>&nbsp;{ label }
        </Button>
        { renderExtras() }
      </>
    );
  }
}
